import { render, staticRenderFns } from "./OperelInvoiceDimensionsForTable.vue?vue&type=template&id=4923fbe0&scoped=true&"
import script from "./OperelInvoiceDimensionsForTable.vue?vue&type=script&lang=ts&"
export * from "./OperelInvoiceDimensionsForTable.vue?vue&type=script&lang=ts&"
import style0 from "./OperelInvoiceDimensionsForTable.vue?vue&type=style&index=0&id=4923fbe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923fbe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VBtn,VCombobox})
